var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "item-linew" }, [_vm._v("活动核销信息")]),
    _c(
      "div",
      { staticClass: "budgetBox" },
      [
        _c(
          "el-form",
          { staticClass: "UniformCss" },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { staticStyle: { height: "auto" }, attrs: { span: 18 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "核销规则描述" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            disabled: Boolean(_vm.activity.actplanid),
                            maxlength: "400",
                            "show-word-limit": "",
                            autosize: { minRows: 2, maxRows: 10 },
                          },
                          model: {
                            value: _vm.activity.writeOffRules,
                            callback: function ($$v) {
                              _vm.$set(_vm.activity, "writeOffRules", $$v)
                            },
                            expression: "activity.writeOffRules",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticStyle: { height: "auto" }, attrs: { span: 18 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "核销材料说明" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            disabled: Boolean(_vm.activity.actplanid),
                            maxlength: "400",
                            "show-word-limit": "",
                            autosize: { minRows: 2, maxRows: 10 },
                          },
                          model: {
                            value: _vm.activity.writeOffMaterial,
                            callback: function ($$v) {
                              _vm.$set(_vm.activity, "writeOffMaterial", $$v)
                            },
                            expression: "activity.writeOffMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticStyle: { height: "auto" }, attrs: { span: 18 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "核销其他说明" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            disabled: Boolean(_vm.activity.actplanid),
                            maxlength: "400",
                            "show-word-limit": "",
                            autosize: { minRows: 2, maxRows: 10 },
                          },
                          model: {
                            value: _vm.activity.writeOffOther,
                            callback: function ($$v) {
                              _vm.$set(_vm.activity, "writeOffOther", $$v)
                            },
                            expression: "activity.writeOffOther",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }